import BaseCollectionService from "./base.collection.service";

class MortgageService extends BaseCollectionService {
  constructor() {
    super("mortgages");
  }
}

export default new MortgageService();
